import reactIcon from "../img/Icons/Logos/ReactLogo.png";

export default function ReactSkill() {
    return (
        <div className="skillTile">
            <img src={reactIcon} alt="csharp"/>
            <div className="skillTexts">
                <h2>React</h2>
            </div>
        </div>
    )
}